import { watchCreatePageUseCase } from 'containers/Admin/Management/Pages/store/sagas/use-cases/watchCreatePageUseCase';
import { watchDeletePageUseCase } from 'containers/Admin/Management/Pages/store/sagas/use-cases/watchDeletePageUseCase';
import { watchGetPageUseCases } from 'containers/Admin/Management/Pages/store/sagas/use-cases/watchGetPageUseCases';
import { watchUpdatePageUseCase } from 'containers/Admin/Management/Pages/store/sagas/use-cases/watchUpdatePageUseCase';

export const sagasPageUseCase = [watchCreatePageUseCase, watchDeletePageUseCase, watchGetPageUseCases, watchUpdatePageUseCase];
